import { createSignal } from 'solid-js';

const STORAGE_KEY = 'uchat-theme';

export type ThemeMode = 'light' | 'dark' | 'system';

const media = window.matchMedia('(prefers-color-scheme: dark)');

const initialMode = (): ThemeMode => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : 'system';
};

const [mode, setMode] = createSignal<ThemeMode>(initialMode());

const apply = () =>
  document.documentElement.classList.toggle(
    'dark',
    mode() === 'dark' || (mode() === 'system' && media.matches),
  );

apply();
media.addEventListener('change', apply); // module-lifetime listener; SPA, no cleanup needed

export const themeMode = mode;

export const setThemeMode = (m: ThemeMode): void => {
  setMode(m);
  localStorage.setItem(STORAGE_KEY, m);
  apply();
};
